import { render } from "./MealSettings.vue?vue&type=template&id=6eefab96&scoped=true"
import script from "./MealSettings.vue?vue&type=script&lang=js"
export * from "./MealSettings.vue?vue&type=script&lang=js"

import "./MealSettings.vue?vue&type=style&index=0&id=6eefab96&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefab96"]])

export default __exports__